export class SlashCommandPlugin {
  private _api: any;
  private _config: any;

  constructor({ api, config }: any) {
    this._api = api;
    this._config = config;
  }

  static get isInline() {
    return true;
  }

  render() {
    return document.createElement('span');
  }

  surround() {}

  checkState() {}

  static get sanitize() {
    return {
      span: true,
    };
  }
}

// Available placeholders
const PLACEHOLDERS = [
  { label: 'Song Name', value: '$releases/name$' },
  { label: 'Release Date', value: '$releases/release_date$' },
  { label: 'Artist Name', value: '$artists/name$' },
  { label: 'Artist Instagram', value: '$artists/instagram_url$' },
  { label: 'Artist TikTok', value: '$artists/tiktok_url$' },
  { label: 'Artist Spotify', value: '$artists/spotify_url$' },
  { label: 'Release Spotify', value: '$releases/spotify_url$' },
  { label: 'Master File URL', value: '$releases/master_file_url$' },
];

// Add keyboard listener to Editor.js for Notion-style slash commands
export function enableSlashCommands(_editor: any, holder: HTMLElement) {
  if (!holder) return;

  let slashMenu: HTMLElement | null = null;
  let placeholderMenu: HTMLElement | null = null;

  function createSlashMenu(target: HTMLElement) {
    // Remove existing menu if any
    if (slashMenu) {
      slashMenu.remove();
    }

    // Create menu
    slashMenu = document.createElement('div');
    slashMenu.className = 'slash-command-menu';
    slashMenu.style.cssText = `
      position: fixed;
      background: black;
      border: 1px solid rgb(55, 65, 81);
      border-radius: 0.5rem;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.5);
      z-index: 9999;
      min-width: 250px;
      max-height: 400px;
      overflow-y: auto;
      padding: 4px;
    `;

    // Get cursor position using Selection API
    const selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      const rect = range.getBoundingClientRect();
      
      // Position menu at cursor
      slashMenu.style.top = `${rect.bottom + 5}px`;
      slashMenu.style.left = `${rect.left}px`;
    } else {
      // Fallback to target position
      const rect = target.getBoundingClientRect();
      slashMenu.style.top = `${rect.bottom + 5}px`;
      slashMenu.style.left = `${rect.left}px`;
    }

    // Trigger the plus button to get the menu items
    const plusButton = target.closest('.ce-block')?.querySelector('.ce-toolbar__plus') as HTMLElement;
    if (plusButton) {
      plusButton.click();
      
      // Wait for popover to appear and clone its items
      setTimeout(() => {
        const popover = document.querySelector('.ce-popover__items');
        if (popover && slashMenu) {
          slashMenu.innerHTML = popover.innerHTML;
          
          // Remove search bar from the cloned menu
          const searchBar = slashMenu.querySelector('.cdx-search-field');
          if (searchBar) {
            searchBar.remove();
          }
          
          document.body.appendChild(slashMenu);
          
          // Close the original popover
          const overlay = document.querySelector('.ce-popover__overlay') as HTMLElement;
          if (overlay) {
            overlay.click();
          }
        }
      }, 50);
    }
  }

  function createPlaceholderMenu(target: HTMLElement) {
    // Remove existing menu if any
    if (placeholderMenu) {
      placeholderMenu.remove();
    }

    // Create menu
    placeholderMenu = document.createElement('div');
    placeholderMenu.className = 'placeholder-menu';
    placeholderMenu.style.cssText = `
      position: fixed;
      background: black;
      border: 1px solid rgb(55, 65, 81);
      border-radius: 0.5rem;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.5);
      z-index: 9999;
      min-width: 300px;
      max-height: 400px;
      overflow-y: auto;
      padding: 4px;
    `;

    // Get cursor position
    const selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      const rect = range.getBoundingClientRect();
      
      placeholderMenu.style.top = `${rect.bottom + 5}px`;
      placeholderMenu.style.left = `${rect.left}px`;
    }

    // Add placeholder items
    PLACEHOLDERS.forEach((placeholder) => {
      const item = document.createElement('div');
      item.style.cssText = `
        padding: 8px 12px;
        cursor: pointer;
        border-radius: 4px;
        color: rgb(156, 163, 175);
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      `;
      item.innerHTML = `<span>${placeholder.label}</span><span style="color: rgb(100, 116, 139); font-size: 12px; font-family: monospace;">${placeholder.value}</span>`;
      
      item.addEventListener('mouseover', () => {
        item.style.background = 'rgb(55, 65, 81)';
        item.style.color = 'white';
      });
      
      item.addEventListener('mouseout', () => {
        item.style.background = 'transparent';
        item.style.color = 'rgb(156, 163, 175)';
      });
      
      item.addEventListener('click', () => {
        const selection = window.getSelection();
        if (selection && selection.rangeCount > 0) {
          // Delete the "$" character
          const text = target.textContent || '';
          const dollarIndex = text.lastIndexOf('$');
          if (dollarIndex !== -1) {
            const beforeDollar = text.substring(0, dollarIndex);
            target.textContent = beforeDollar + placeholder.value;
            
            // Move cursor to end of placeholder
            const newRange = document.createRange();
            newRange.selectNodeContents(target);
            newRange.collapse(false);
            selection.removeAllRanges();
            selection.addRange(newRange);
          }
        }
        
        if (placeholderMenu) {
          placeholderMenu.remove();
          placeholderMenu = null;
        }
      });
      
      if (placeholderMenu) {
        placeholderMenu.appendChild(item);
      }
    });

    document.body.appendChild(placeholderMenu);
  }

  function removeSlashMenu() {
    if (slashMenu) {
      slashMenu.remove();
      slashMenu = null;
    }
  }

  function removePlaceholderMenu() {
    if (placeholderMenu) {
      placeholderMenu.remove();
      placeholderMenu = null;
    }
  }

  holder.addEventListener('input', (e: Event) => {
    const target = e.target as HTMLElement;
    
    // Check if user typed "/"
    if (target.classList.contains('ce-paragraph') || target.classList.contains('ce-header') || target.closest('.ce-paragraph') || target.closest('.ce-header')) {
      const text = target.textContent || '';
      
      console.log('Input detected in editor block:', text, 'Classes:', target.className);
      
      // Check if the last character is "/" and it's at the start or after a space
      if (text.endsWith('/') && (text.length === 1 || text[text.length - 2] === ' ')) {
        console.log('Slash detected, showing menu');
        
        // Save cursor position
        const selection = window.getSelection();
        const range = selection?.getRangeAt(0);
        
        // Remove the "/"
        target.textContent = text.slice(0, -1);
        
        // Restore cursor position
        if (range && selection) {
          const newRange = document.createRange();
          newRange.selectNodeContents(target);
          newRange.collapse(false);
          selection.removeAllRanges();
          selection.addRange(newRange);
        }
        
        // Show inline menu
        createSlashMenu(target);
      }

      // Check if the last character is "$" and it's at the start or after a space
      if (text.endsWith('$') && (text.length === 1 || text[text.length - 2] === ' ')) {
        console.log('Dollar detected, showing placeholder menu');
        
        // Save cursor position
        const selection = window.getSelection();
        const range = selection?.getRangeAt(0);
        
        // Remove the "$"
        target.textContent = text.slice(0, -1);
        
        // Restore cursor position
        if (range && selection) {
          const newRange = document.createRange();
          newRange.selectNodeContents(target);
          newRange.collapse(false);
          selection.removeAllRanges();
          selection.addRange(newRange);
        }
        
        // Show placeholder menu
        createPlaceholderMenu(target);
      }
    }
  });

  holder.addEventListener('keydown', (e: KeyboardEvent) => {
    // Close menu on Escape
    if (e.key === 'Escape') {
      removeSlashMenu();
      removePlaceholderMenu();
      return;
    }
  });

  // Close menu when clicking outside
  document.addEventListener('click', (e) => {
    if (slashMenu && !slashMenu.contains(e.target as Node)) {
      removeSlashMenu();
    }
    if (placeholderMenu && !placeholderMenu.contains(e.target as Node)) {
      removePlaceholderMenu();
    }
  });
}
